// extracted by mini-css-extract-plugin
module.exports = {"services":"styles_services__3t1Wd","panel":"styles_panel__3fRiy","service":"styles_service__QJjLL","title":"styles_title__23OLF"};